// extracted by css-extract-rspack-plugin
export default {"row":"CharacteristicValuesList_row__apXZp","cellButtonOpen":"CharacteristicValuesList_cellButtonOpen__RGhw2"};